/** Format helpers — bytes/rub/datetime для всей админки. */

export const fmtRub = (n: number) =>
  new Intl.NumberFormat("ru-RU").format(n) + " ₽";

export const fmtBytes = (n: number) => {
  if (n < 1024) return `${n} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i++; }
  return `${v.toFixed(v < 10 ? 2 : v < 100 ? 1 : 0)} ${units[i]}`;
};

export const fmtDateTime = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString("ru-RU") : "—";

export const fmtDate = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleDateString("ru-RU") : "—";

export const fmtUserName = (u: {
  username?: string | null; first_name?: string | null; tg_id?: number | null;
  user_id?: number | null;
}): string =>
  u.username
    ? `@${u.username}`
    : u.first_name || `tg:${u.tg_id ?? u.user_id ?? "?"}`;

export const daysLeft = (iso: string | null | undefined): number | null => {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
};

// Флаг + красивое имя по строке локации ноды. Зеркалит COUNTRY_FLAGS из
// api/routes/subscriptions.py (substring-match, регистронезависимо), чтобы
// в UI «Online сейчас» и в карточке нода показывалась с флагом страны.
const COUNTRY_FLAGS: [string, string, string][] = [
  ["helsinki", "🇫🇮", "Helsinki"],
  ["finland", "🇫🇮", "Finland"],
  ["amsterdam", "🇳🇱", "Amsterdam"],
  ["netherlands", "🇳🇱", "Netherlands"],
  ["vienna", "🇦🇹", "Vienna"],
  ["austria", "🇦🇹", "Austria"],
  ["frankfurt", "🇩🇪", "Frankfurt"],
  ["germany", "🇩🇪", "Germany"],
  ["london", "🇬🇧", "London"],
  ["paris", "🇫🇷", "Paris"],
  ["warsaw", "🇵🇱", "Warsaw"],
  ["stockholm", "🇸🇪", "Stockholm"],
  ["tallinn", "🇪🇪", "Tallinn"],
  ["zurich", "🇨🇭", "Zurich"],
  ["milan", "🇮🇹", "Milan"],
  ["madrid", "🇪🇸", "Madrid"],
  ["riga", "🇱🇻", "Riga"],
  ["new york", "🇺🇸", "New York"],
  ["ny", "🇺🇸", "New York"],
];

/** "🇦🇹 Vienna" по строке локации; "🌍 <как есть>" если не распознано. */
export const countryFlag = (location: string | null | undefined): string => {
  if (!location) return "🌍 —";
  const lo = location.toLowerCase();
  for (const [key, flag, nice] of COUNTRY_FLAGS) {
    if (lo.includes(key)) return `${flag} ${nice}`;
  }
  return `🌍 ${location}`;
};

/** "5 сек назад" / "3 мин назад" — компактный relative-time для online-таблицы. */
export const fmtAgo = (iso: string | null | undefined): string => {
  if (!iso) return "—";
  const sec = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (sec < 60) return `${sec} сек назад`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} мин назад`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h} ч назад`;
  return `${Math.floor(h / 24)} д назад`;
};
